import {
    SET_CONTRIBUTOR,
    DELETE_CONTRIBUTOR,
  } from "../constant";
  
  const initialState = [];
  
  export const contributorReducer = (
    state = initialState,
    { type, payload }
  ) => {
    switch (type) {
      case SET_CONTRIBUTOR: {
        state = [...payload];
        return state;
      }
      case DELETE_CONTRIBUTOR: {
        let temp = [...state];
        let index = temp.findIndex((user) => user._id === payload);
        if (index > -1) {
          temp.splice(index, 1);
        }
        return temp;
      }
      default: {
        return state;
      }
    }
  };
  